import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import {
  AbsenceEntry,
  ModalService,
  RouterService,
  StateService,
  ToolService,
} from 'projects/shared/src/public-api';
import { Subscription } from 'rxjs';

@Component({
  selector: 'lib-absence-overview',
  templateUrl: './absence-overview.component.html',
  styleUrls: ['./absence-overview.component.scss'],
  standalone: false,
})
export class AbsenceOverviewComponent implements OnInit {
  constructor(
    public routerService: RouterService,
    public state: StateService,
    public tools: ToolService,
    public modalService: ModalService
  ) {}
  private sub: Subscription;
  public allEntries: AbsenceEntry[] = [];
  public filteredEntries: AbsenceEntry[] = [];
  public selectedEntries: AbsenceEntry[] = [];
  public selectedWorker: string;
  public selectedMonth: number = new Date().getMonth();
  public selectedYear: number = new Date().getFullYear();
  public allSelected: boolean = false;
  public selectedEntriesValid: boolean = false;
  private initialized: boolean = false;
  @Output()
  selectedWorkerChanged: EventEmitter<string> = new EventEmitter<string>();

  ngOnInit() {
    this.sub = this.state.absenceEntries$.subscribe((x) => {
      this.filteredEntries = x;
      this.allEntries = x;
      if (!this.state.userHasMinType(1) && !this.initialized) {
        this.selectedWorker = this.state.userName;
      } else {
        this.selectedWorker = null;
      }
      this.filterEntries();
      this.initialized = true;
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  userChange(e: any) {
    this.selectedWorker = e;
    this.selectedWorkerChanged.emit(this.selectedWorker);
    this.filterEntries();
  }

  monthChange(month: number) {
    this.selectedMonth = month;
    this.filterEntries();
  }

  yearChange(year: number) {
    this.selectedYear = year;
    this.filterEntries();
  }

  filterEntries() {
    this.filteredEntries = this.allEntries;
    if (this.selectedWorker != null) {
      this.filteredEntries = this.filteredEntries.filter(
        (x) => x.user == this.selectedWorker
      );
    }
    if (this.selectedMonth != null) {
      this.filteredEntries = this.filteredEntries.filter(
        (x) => new Date(x.date).getMonth() == this.selectedMonth
      );
    }
    if (this.selectedYear != null) {
      this.filteredEntries = this.filteredEntries.filter(
        (x) => new Date(x.date).getFullYear() == this.selectedYear
      );
    }
  }

  async addButtonClicked() {
    await this.modalService.openAbsenceFormModal(null);
  }

  isSelected(entry: AbsenceEntry): boolean {
    return this.selectedEntries.includes(entry);
  }

  toggleSelection(entry: AbsenceEntry) {
    if (this.isSelected(entry)) {
      this.selectedEntries.splice(this.selectedEntries.indexOf(entry), 1);
    } else {
      this.selectedEntries.push(entry);
    }

    this.selectedEntriesValidCheck();
  }

  toggleAll() {
    if (this.allSelected) {
      this.selectedEntries = [];
    } else {
      this.selectedEntries = [...this.filteredEntries];
    }
    this.allSelected = !this.allSelected;

    this.selectedEntriesValidCheck();
  }

  public selectedEntriesValidCheck(): void {
    let valid = true;
    if (this.selectedEntries.length == 0) {
      this.selectedEntriesValid = false;
      return;
    }
    this.selectedEntries.forEach((x) => {
      if (x.approvedBy != null) {
        valid = false;
      }
    });
    if (this.state.isOfficeUser) {
      this.selectedEntriesValid = true;
      return;
    }
    this.selectedEntriesValid = valid;
  }

  public async delete() {
    const result = await this.state.deleteMultipleAbsenceEntry(
      this.selectedEntries.map((x) => x.id)
    );
    if (result) {
      this.selectedEntriesValid = false;
      this.allSelected = false;
      this.selectedEntries = [];
    }
  }
}
